import styled from 'styled-components';
import PropTypes from 'prop-types';

const MainContainer = styled.div`
    margin-bottom: 0.5em;
`;

const Label = styled.label.attrs(
    (props) =>
        props.width && {
            style: { width: props.width, display: 'inline-block' },
        }
)`
    ${(props) => props.disabled && `color: #ccc;`}
`;

const Input = styled.input.attrs((props) => {
    const attrs = {
        type: 'checkbox',
    };
    if (props.width) {
        attrs.style = { width: props.width, display: 'inline-block' };
    }
    return attrs;
})``;

const Checkbox = ({
    label,
    labelWidth,
    id,
    value,
    onChange,
    disabled,
    ...props
}) => {
    const handleChange = (ev) => {
        // const inputValue = ev.target.value;
        // console.log("inputValue:", inputValue);
        onChange(!value);
    };

    return (
        <MainContainer {...props}>
            <Input
                checked={value}
                onChange={handleChange}
                disabled={disabled}
            />
            {label && (
                <Label width={labelWidth} htmlFor={id} disabled={disabled}>
                    {label}
                </Label>
            )}
        </MainContainer>
    );
};

Checkbox.propTypes = {
    label: PropTypes.node,
    value: PropTypes.any,
    onChange: PropTypes.func, // function(value){}
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Checkbox;
